export default {
  Title: 'Users',
  Action: 'Create new user',
  UserStatus: 'User status: ',
  Filter: {
    Status: 'Status',
    StatusOptions: {
      ACTIVE: 'Active',
      INACTIVE: 'Inactive',
    },
    Role: 'Role',
    RoleOptions: {
      ADMIN: 'Admin',
      CAREGIVER: 'Caregiver',
      CLIENT: 'Client',
    },
  },
  Card: {
    UserStatus: 'Status: #{status}',
    Status: {
      ACTIVE: 'Active',
      INACTIVE: 'Inactive',
    },
    Role: 'Role: #{status}',
    RoleOptions: {
      ADMIN: 'Admin',
      CAREGIVER: 'Caregiver',
      CLIENT: 'Client',
    },
    Email: 'Email: #{email}',
    Action: {
      Deactivate: 'Deactivate',
    },
  },
};
